import React from 'react'
import Head from 'next/head'
import { Montserrat } from 'next/font/google'
import type { AppProps } from 'next/app'
import { useRouter } from 'next/router'
import { Providers } from '@/application/Providers'
import { useHashRedirect } from '@/application/features/hashRedirect/useHashRedirect'
import { getEnvironmentConfig } from '@/application/Environment/getEnvironmentConfig'
import { PlannedMaintenance } from '@/components/PlannedMaintenance'

const montserrat = Montserrat({
  weight: ['400', '500', '600', '700'],
  subsets: ['latin'],
})

const MyApp = ({ Component, pageProps }: AppProps) => {
  useHashRedirect()

  const config = getEnvironmentConfig()
  const router = useRouter()
  const bypassMaintenance = router.query.bypass === 'true'

  if (config.plannedMaintenance && !bypassMaintenance) {
    return (
      <>
        <Head>
          <title>Tumelo ProxySphere - Retail</title>
          <link rel="icon" href="/images/favicon.ico" type="image/x-icon" />
        </Head>
        <div className={montserrat.className}>
          <PlannedMaintenance />
        </div>
      </>
    )
  }

  return (
    <>
      <Head>
        <title>Tumelo ProxySphere - Retail</title>
        <link rel="icon" href="/images/favicon.ico" type="image/x-icon" />
      </Head>
      <div className={montserrat.className}>
        <Providers>
          <Component {...pageProps} />
        </Providers>
      </div>
    </>
  )
}

export default MyApp
